export const DURUM_RENKLERI: Record<string, string> = {
  'Yeni Rezervasyon': 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  'Onaylandı': 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
  'Araç Atandı': 'bg-vip-gold/20 text-vip-gold border-vip-gold/30',
  'Araca Bildirildi': 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  'Yolda': 'bg-orange-500/20 text-orange-300 border-orange-500/30',
  'Müşteri Alındı': 'bg-cyan-500/20 text-cyan-300 border-cyan-500/30',
  'Transfer Tamamlandı': 'bg-green-500/20 text-green-300 border-green-500/30',
  'İptal Edildi': 'bg-red-500/20 text-red-400 border-red-500/30',
  'Ödeme Bekliyor': 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30',
};

export const ARAC_DURUM_RENKLERI: Record<string, string> = {
  'Müsait': 'bg-emerald-500/20 text-emerald-300',
  'Görevde': 'bg-blue-500/20 text-blue-300',
  'Bakımda': 'bg-red-500/20 text-red-400',
};

export const ARAC_TIPLERI = [
  'Mercedes Vito',
  'Mercedes E-Sınıfı',
  'Mercedes Sprinter',
  'BMW 7 Serisi',
];

export const PARA_BIRIMLERI = ['EUR', 'USD', 'TL', 'GBP'];

export const DURUMLAR = [
  'Yeni Rezervasyon',
  'Onaylandı',
  'Araç Atandı',
  'Araca Bildirildi',
  'Yolda',
  'Müşteri Alındı',
  'Transfer Tamamlandı',
  'İptal Edildi',
  'Ödeme Bekliyor',
];

export const ARAC_DURUMLARI = ['Müsait', 'Görevde', 'Bakımda'];

export const TODAY = new Date().toISOString().split('T')[0];

export const ILCELER = [
  'Antalya Havalimanı',
  'Alanya',
  'Side',
  'Belek',
  'Kemer',
  'Lara',
  'Konyaaltı',
  'Manavgat',
  'Kaş',
  'Kalkan',
  'Serik',
];

export const TRANSFER_TIPLERI = ['Tek Yön', 'Gidiş-Dönüş'];

export const ALINIS_YERLERI = [
  'Antalya Havalimanı',
  'Gazipaşa Havalimanı',
  'Side',
  'Alanya',
  'Belek',
  'Kemer',
  'Lara',
  'Konyaaltı',
  'Manavgat',
  'Kaş',
  'Kalkan',
  'Serik',
];

export const BIRAKIS_YERLERI = [
  'Yok',
  'Antalya Havalimanı',
  'Gazipaşa Havalimanı',
  'Side',
  'Alanya',
  'Belek',
  'Kemer',
  'Lara',
  'Konyaaltı',
  'Manavgat',
  'Kaş',
  'Kalkan',
  'Serik',
];